import React from 'react';
import { TomeButton } from '../../primitives/tome';
import { EntryPanel } from './EntryPanel';
import { EntryBuildStatus } from './EntryBuildStatus';

interface GreeterScreenProps { username: string; onNext: () => void }

export const GreeterScreen: React.FC<GreeterScreenProps> = ({ username, onNext }) => (
  <EntryPanel wide label="Welcome" actions={<TomeButton fullWidth cut="clean" onClick={onNext}>Continue to your heroes</TomeButton>}>
    <h1>Welcome, {username}</h1>
    <p className="entry-screen__lead">A familiar hero or a new beginning — choose the journey that calls to you.</p>
    <div className="entry-screen__journey">
      <div className="entry-screen__well">
        <img className="entry-screen__art" src="/icons/abilities/healing_touch.svg" alt="" />
        <h2>Return to your heroes</h2>
        <p>Choose a saved character and continue where their journey left off.</p>
      </div>
      <div className="entry-screen__well">
        <img className="entry-screen__art" src="/icons/abilities/word_of_shielding.svg" alt="" />
        <h2>A new beginning</h2>
        <p>Create a hero with their own calling, appearance, and story.</p>
      </div>
    </div>
    <div className="entry-screen__build"><EntryBuildStatus /></div>
  </EntryPanel>
);
